export default __webpack_public_path__ + "static/epc-39527bce38b4bbc0caa103654140a34a.png";